export const SET_INEP = 'INEP/SET_INEP'
export const SET_INEPS = 'INEP/SET_INEPS'
